var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStorybook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 25,
    viewBox: "0 0 20 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.744335 22.6152L0.000864114 2.80507C-0.0236898 2.15082 0.477966 1.59635 1.1314 1.55551L17.9813 0.502391C18.6464 0.460821 19.2193 0.966308 19.2609 1.63143C19.2625 1.65649 19.2632 1.68159 19.2632 1.7067V23.2933C19.2632 23.9598 18.723 24.5 18.0566 24.5C18.0385 24.5 18.0205 24.4996 18.0024 24.4988L1.896 23.7754C1.26872 23.7472 0.767884 23.2427 0.744335 22.6152Z",
    fill: "#FF4785"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2244 3.44998L14.3395 0.681814L16.6535 0.5L16.7532 3.35472C16.7567 3.45407 16.679 3.53742 16.5796 3.54089C16.5371 3.54237 16.4954 3.52874 16.462 3.50239L15.5696 2.79943L14.5131 3.60087C14.4339 3.66095 14.321 3.64545 14.2609 3.56624C14.2356 3.5329 14.2227 3.49179 14.2244 3.44998ZM11.2651 9.54593C11.2651 10.0154 14.4273 9.79039 14.8518 9.46062C14.8518 6.26371 13.1364 4.58379 9.99523 4.58379C6.85407 4.58379 5.09412 6.28985 5.09412 8.84895C5.09412 13.306 11.1091 13.3913 11.1091 15.8225C11.1091 16.5049 10.775 16.9101 10.0398 16.9101C9.08184 16.9101 8.70312 16.4209 8.74768 14.7575C8.74768 14.3966 5.09412 14.2841 4.98273 14.7575C4.69909 18.7885 7.21051 19.9512 10.0843 19.9512C12.8691 19.9512 15.0523 18.4669 15.0523 15.7798C15.0523 11.0029 8.94818 11.1308 8.94818 8.76365C8.94818 7.80398 9.66107 7.67603 10.0843 7.67603C10.5299 7.67603 11.3319 7.75456 11.2651 9.54593Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStorybook);
export default __webpack_public_path__ + "static/media/storybook.778758f265bb309f427f6f121a1bdccd.svg";
export { ForwardRef as ReactComponent };